export default "/images/vendor/flag-icons/flags/4x3/xx.svg?96f901b4ca23142ad779d70300e6936e";